import merge from 'lodash.merge';
import { Validators } from '@angular/forms';

import { VALIDATION_RULES } from '~shared/constants';

export const REGISTRATION_VALIDATION_RULES = merge({}, VALIDATION_RULES, {
  firstName: {
    required: Validators.required,
  },
  lastName: {
    required: Validators.required,
  },
});

export const REGISTRATION_WITH_HORECA_MANDATORY = merge({}, REGISTRATION_VALIDATION_RULES, {
  isHoreca: {
    required: Validators.required,
  },
});
